package org.example.project.screens_cus_mobile.wa

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun CUSMobileWAAbschlussScreen(
    leergut: String,
    showLeergutKontrolle: Boolean,
    onLeergutChange: (String) -> Unit,
    istPaletten: String,
    onIstPalettenChange: (String) -> Unit
) {
    if (showLeergutKontrolle) {
        CUSMobileWAPalettenGetauschtField(leergut, onLeergutChange)
    }
    Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900"); lineHeight("1.3") } }) {
        Text("Bestätige, dass alle Paletten verladen wurden.")
    }
    CUSMobileWANumberField(istPaletten, "Ist-Menge", onIstPalettenChange)
}

@Composable
fun CUSMobileWATeilabschlussScreen(
    row: All,
    rowKey: String,
    value: String,
    palettenIstLabel: String,
    onValueChange: (String) -> Unit
) {
    Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(13.px); fontWeight("800") } }) {
        Text("Lieferscheinnummer ${row.lieferscheinnummer.ifBlank { rowKey }}")
    }
    Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900"); lineHeight("1.3") } }) {
        Text("Bestätige, dass alle Paletten verladen wurden.")
    }
    CUSMobileWANumberField(value, palettenIstLabel, onValueChange)
}

@Composable
private fun CUSMobileWAPalettenGetauschtField(value: String, onValueChange: (String) -> Unit) {
    Div({ style { width(100.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(14.px) } }) {
        Span({ style { color(DashboardTheme.TEXT_LIGHT); fontSize(17.px); fontWeight("900"); lineHeight("1.3") } }) {
            Text("Hast du Paletten getauscht?")
        }
        CUSMobileWANumberField(value, "Menge", onValueChange)
    }
}

@Composable
private fun CUSMobileWANumberField(value: String, placeholder: String, onValueChange: (String) -> Unit) {
    Input(InputType.Number) {
        value(value)
        attr("placeholder", placeholder)
        style {
            height(56.px)
            width(100.percent)
            padding(0.px, 14.px)
            color(DashboardTheme.TEXT_LIGHT)
            backgroundColor(Color("rgba(255,255,255,0.04)"))
            property("border", "1px solid rgba(255,255,255,0.14)")
            borderRadius(8.px)
            property("box-sizing", "border-box")
            fontSize(22.px)
            fontWeight("900")
            textAlign("center")
        }
        onInput { onValueChange(it.value?.toString().orEmpty().filter(Char::isDigit)) }
    }
}

@Composable
private fun CUSMobileWACenteredButton(
    label: String,
    variant: LumaticaButtonVariant,
    enabled: Boolean,
    onClick: () -> Unit
) {
    Div({ style { width(260.px); maxWidth(100.percent) } }) {
        LumaticaButton(label, onClick, variant = variant, heightPx = 42, enabled = enabled)
    }
}
